import * as Color from "color"
import PptxGenJS, { Slide } from "pptxgenjs"
import { Decomposition } from "../debt-table"
import * as DebtUtils from "../utils"
import { MasterSlide } from "../../pptx-configuration/master-slides"
import {
  Placeholder,
  getPlaceholderChartBodyOptions
} from "../../pptx-configuration/placeholders"
import { DocumentSection } from "../../types"
import { formatTitle } from "../../utils"
import { ReportConfiguration } from "../../../configuration"
import { LoanWithDecomposition, LocalAuthority, Ppi, Scenario } from "../../../../../model"

export function checkAnnuitySection(
  configuration: ReportConfiguration
): boolean {
  const annuity = configuration.debt.annuity
  return annuity.globalCharts || annuity.tables
}

export function createAnnuitySection(
  pptx: PptxGenJS,
  configuration: ReportConfiguration,
  numbering: number[],
  decomposedLoans: LoanWithDecomposition[],
  years: number[],
  localAuthority:LocalAuthority,
  loans:any,
  scenario:Scenario,
  ppi?:Ppi
): DocumentSection {
  const slides: Slide[] = []
  const slidesTitle = formatTitle("Annuités", numbering)
  const annuity = configuration.debt.annuity
  const placeholderBody = getPlaceholderChartBodyOptions()
  const baseColor = new Color(configuration.table.header.backgroundColor)

  if (annuity.tables) {
    DebtUtils.includeDebtTable(
      pptx,
      slidesTitle,
      "management-report-debt-annuity",
      Decomposition.Annuity,
      decomposedLoans,
      years,
      configuration
    )
  }

  if (annuity.PieChartType) {
    const slide = pptx.addNewSlide(MasterSlide.Chart)

    slide.addText(slidesTitle, {
      placeholder: Placeholder.Title
    })

    const pieChartData = DebtUtils.createPieChartData(
      decomposedLoans,
      "annuity",
      configuration.generalities.referenceYear
    )

    const pieChartOptions = DebtUtils.createPieChartOptions(
      pieChartData,
      placeholderBody,
      baseColor
    )
    slides.push(slide)
    slide.addChart(pptx.charts.PIE, pieChartData, pieChartOptions)
  }

  if (annuity.globalCharts) {
    const slide = pptx.addNewSlide(MasterSlide.Chart)

    slide.addText(slidesTitle, {
      placeholder: Placeholder.Title
    })
    
    const chartData = DebtUtils.createChartData(
      Decomposition.Annuity,
      decomposedLoans,
      years,
      localAuthority,
      loans,
      scenario,
      ppi
    )

    const chartOptions = DebtUtils.createGlobalChartOptions(baseColor);

    slide.addChart(pptx.charts.BAR, chartData, chartOptions)

    slides.push(slide)
  }

  if (annuity.perBank || annuity.perRateType) {
    const slide = pptx.addNewSlide(MasterSlide.Chart)

    slide.addText(slidesTitle, {
      placeholder: Placeholder.Title
    })

    if (annuity.perBank) {
      const perBankChartData = DebtUtils.createPerBankChartData(
        decomposedLoans,
        "annuity",
        configuration.generalities.referenceYear
      )

      const perBankChartOptions = DebtUtils.createPerBankChartOptions(
        perBankChartData,
        annuity.perRateType,
        placeholderBody,
        baseColor
      )

      slide.addChart(pptx.charts.PIE, perBankChartData, perBankChartOptions)
    }

    if (annuity.perRateType) {
      const perRateTypeChartData = DebtUtils.createPerRateTypeChartData(
        decomposedLoans,
        "annuity",
        configuration.generalities.referenceYear
      )

      const perRateTypeChartOptions = DebtUtils.createPerRateTypeChartOptions(
        annuity.perBank,
        placeholderBody,
        baseColor
      )

      slide.addChart(
        pptx.charts.PIE,
        perRateTypeChartData,
        perRateTypeChartOptions
      )
    }

    slides.push(slide)
  }

  return { slides, title: slidesTitle }
}



// WEBPACK FOOTER //
// ./src/component/management-report/generator/debt-generator/annuity-generator/index.tsx